module.exports = __webpack_public_path__ + "static/media/cases_ilustracoes_new06.6d35ba73.jpg";